import { SxProps, Theme, Typography } from '@mui/material';

export const SectionHeader = ({ title, sx }: { title: string; sx?: SxProps<Theme> }) => {
  return (
    <Typography variant="overline" fontSize="0.75rem" sx={sx}>
      {title}
    </Typography>
  );
};
